module.exports = __webpack_public_path__ + "_app/img/bose.3c0e45c9.svg";